import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASEURL } from '../../constants/Common';
import { Box, Typography, Paper, Button } from "@mui/material";
import BasicTable, { Column } from '../../components/table';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

export interface Invoice {
    business_name: string;
    business_address: string;
    business_city: string;
    business_email: string;
    business_phone: string;
    client_name: string;
    client_address: string;
    client_city: string;
    client_email: string;
    invoice_number: string;
    invoice_date: string;
    client_phone: string;
    tax_identification_no: string;
    payment_terms: string;
    hst_registration: string;
    business_registration: string;
    payment_option: string;
    total_without_tax: number;
    total_tax: number;
    total_with_tax: number;
    status: string;
    org_id: string;
    invoice_rows: [];
    logo?: string | File; 
}


const InvoicesList: React.FC = () => {
    const navigate = useNavigate();
    const orgId = localStorage.getItem('orgid'); // Example org_id
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [error, setError] = useState<string | null>(null);


    const fetchInvoicesByOrgId = async (orgId: string): Promise<Invoice[]> => {
        try {
            const response = await axios.get(`${BASEURL}/fetch-invoices/`, {
                params: { orgId },
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch invoices:', error);
            throw error;
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!orgId) {
                    setError('Organization ID is missing.');
                    return;
                }
                const data = await fetchInvoicesByOrgId(orgId);
                setInvoices(data);
            } catch (err) {
                setError('Failed to load invoices. Please try again.');
            }
        };

        fetchData();
    }, []);





    // const handleViewInvoice = (invoice: Invoice) => {
    //     navigate('/invoicetemp', { state: { invoice } }); // Pass the invoice data as state
    //   };

    const handleViewInvoice = (invoice: Invoice) => {
        // Format the invoice date before passing it to the next page
        const formattedDate = invoice.invoice_date ? format(new Date(invoice.invoice_date), 'MM/dd/yyyy') : '';
        navigate('/createinvoice', { state: { invoice: { ...invoice, invoice_date: formattedDate, logo: invoice.logo } } }); // Pass formatted invoice data
    };
    // Define the columns for the table
    const columns: Column[] = [
        { id: 'invoice_number', label: 'Invoice Number', align: 'left' },
        { id: 'invoice_date', label: 'Invoice Date', align: 'left' },
        { id: 'status', label: 'Status', align: 'left' },
        { id: 'action', label: 'Action', align: 'left' },
    ];

    // Map invoice data into rows with the required structure
    const rows = invoices.map((invoice, index) => ({
        id: index + 1, // Ensure each row has a unique id
        invoice_number: invoice.invoice_number,
        invoice_date: invoice.invoice_date,
        status: invoice.status,
        action: (
            <Button variant='contained' onClick={() => handleViewInvoice(invoice)}>View</Button>
        ),
    }));


    return (
        <div>
            <h3>Invoices</h3>
            <Box sx={{ marginTop: '20px' }}>
                <BasicTable columns={columns} rows={rows} />
            </Box>

        </div>
    );
};

export default InvoicesList;
